// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2OkM6","actions":"GroupTable_actions__3g3HZ","deleteModalFooter":"GroupTable_deleteModalFooter__2WyEN"};